export const FOLDER_DATA_TRANSFER_KEY = 'text/lexian-source-folder-id';
export const DOCUMENT_DATA_TRANSFER_KEY = 'text/lexian-document-id';
export const DOCUMENT_NAME_TRANSFER_KEY = 'text/lexian-document-name';
export const DOCUMENT_TYPE_TRANSFER_KEY = 'text/lexian-document-type';
export const EMAIL_SUBJECT_TRANSFER_KEY = 'text/lexian-email-subject';
export const EMAIL_DATA_TRANSFER_KEY = 'text/lexian-email-id';
export const EMAIL_SELECTED_TRANSFER_KEY = 'text/lexian-email-id-selected';
export const CASUS_DATA_TRANSFER_KEY = 'text/lexian-casus-id';
export const CASUS_DISPLAYNAME_TRANSFER_KEY = 'text/lexian-casus-name';
export const ADDITIONAL_FILESHELF_INFO =
  'text/lexian-fileshelf-additional-info';
export const FINANCE_EXPORT_RECEIPT_ID_TRANSFER_KEY =
  'text/lexian-finance-export-id';
